// --- Authentication & User Management
import {
    fetchUserPermissions,
    logout,
    setAuthToken,
    setAuthUser,
    setSessionStart,
} from './actions';
import { getCurrentUser, getToken } from '../../utils/localStorageService';
// --- Configuration Constants
import { LICENSE_KEY } from '../../config/constants';
// --- Third-Party Libraries
import { LicenseManager } from 'ag-grid-enterprise';

// --- Set the license key for ag-Grid
LicenseManager.setLicenseKey(LICENSE_KEY);

/**
 * Action to set the session start time.
 *
 * This action is dispatched to set the session start time in the Redux store.
 * It takes a payload containing the session start time.
 *
 * @returns {(function(*): Promise<void>)|*}
 */
const initialize = () => async (dispatch) => {
    await dispatch(setAuthToken(getToken()));
    await dispatch(setAuthUser(getCurrentUser()));
};

export { fetchUserPermissions, logout, setAuthToken, setAuthUser, initialize, setSessionStart };
